import { Component, OnInit, Output, EventEmitter ,NgZone,ChangeDetectorRef,AfterViewInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';

@Component({
    selector: 'app-new-pushlist',
    templateUrl: './new-pushlist.component.html',
    styleUrls: ['./new-pushlist.component.css']
})

export class NewPushlistComponent implements OnInit {
    @Output() notify = new EventEmitter<any>();
    power:number = 0;

    constructor(
        public httpClient: HttpClient,
        private ngZone: NgZone,
        private cdr: ChangeDetectorRef,


    ){}



    ngOnInit(): void {
        this.init_list();
        this.power = Dep.auth.power_id;
    }

    search_model:string = '';
    sort_model:string = 'desc';
    order_model:string = 'id';
    data:any=[];
    edit_data:any={info:{has_pic:0,is_fuzzy:0,available_week:[0,1,2,3,4,5,6]},ps_id:'1',gender:'1',target:'4',route_sign:'-1',title_tpl:'',content_tpl:'',name:'',is_enable:'1'};
    default_data:any={info:{has_pic:0,is_fuzzy:0,available_week:[0,1,2,3,4,5,6]},ps_id:'1',gender:'1',target:'4',route_sign:'-1',title_tpl:'',content_tpl:'',name:'',is_enable:'1'};
    loading:boolean=true;
    msg :string = '';
    mouse_obj:{start:number,end:number,select:number,target:number} = {start:0,end:0,select:0,target:0}
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))

    type_list:menulist = []
    time_list:menulist = []
    push_num:any = 0;
    click_num_rate:any = 0;
    sms_push_num:any = 0;
    sms_click_num_rate:any = 0;

    menu_now:string = '2';
    sub_now:string = '2';
    now:string = '1';
    search_type_id:string = '-1';
    day_list:menulist = [
        {id:'0',name:'星期日'},
        {id:'1',name:'星期一'},
        {id:'2',name:'星期二'},
        {id:'3',name:'星期三'},
        {id:'4',name:'星期四'},
        {id:'5',name:'星期五'},
        {id:'6',name:'星期六'},
    ]
    varable_list:menulist = [
        {id:'{{user_name}}',name:'推薦對象'},
        {id:'{{self_user_name}}',name:'推播對象'},
        {id:'{{rand_1_9_num}}',name:'隨機一位數'},
        {id:'{{rand_10_99_num}}',name:'隨機二位數'},
        {id:'{{rand_100_999_num}}',name:'隨機三位數'},
        // {id:'{{user_age}}',name:'推薦人歲數'},
        // {id:'{{match_score}}',name:'兩人匹配度'}
    ]
    menu_list:menulist = [
        // {id:'1',name:'互動推播訊息'},
        {id:'2',name:'定期推播設定'},
        {id:'3',name:'觸發推播模板'},
        {id:'4',name:'定期推播統計'},
        {id:'5',name:'一次性推播列表'},
        {id:'6',name:'一次性推播模板'}
    ]

    textreadonly = [];

    genderarr = ['','男生','女生'];

    tcontent = [
        {title:'預覽畫面',content:'view',type:3,css:'max-width: 400px;'},
        {title:'名稱',content:'name'},
        // {title:'標題',content:'title_tpl'},
        // {title:'訊息',content:'content_tpl'},
        // {title:'推播對象性別',content:'gender',type:3},
        {title:'推播時間',content:'ps_id',type:3},
        {title:'是否啟用',content:'is_enable',type:3},
        {title:'導入頁面',content:'route_sign_name'},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent_active = [
        {title:'名稱',content:'name'},
        {title:'標題',content:'title_tpl'},
        {title:'訊息',content:'content_tpl'},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent_push_type_tpl_active = [
        {title:'名稱',content:'name'},
        {title:'標題模板',content:'title_tpl'},
        {title:'內容模板',content:'content_tpl'},
        {title:'收推播者性別',content:'gender',type:3},
        {title:'狀態',content:'is_enable',type:3},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent_once_push = [
        {title:'預覽畫面',content:'view',type:3,css:'max-width: 400px;'},
        {title:'備註',content:'memo'},
        {title:'通知方式',content:'inform_method',type:3},
        {title:'推播時間',content:'push_time',css:'min-width: 100px;',sort:'push_time'},
        {title:'配對數',content:'match_num',css:'min-width: 100px;',sort:'match_num'},
        {title:'推播數',content:'push_num',css:'min-width: 100px;',sort:'push_num'},
        {title:'推播點擊數',content:'click_num',css:'min-width: 100px;',sort:'click_num'},
        {title:'簡訊數',content:'sms_push_num',css:'min-width: 100px;',sort:'sms_push_num'},
        {title:'簡訊點擊數',content:'sms_click_num',css:'min-width: 130px;',sort:'sms_click_num'},
        {title:'登入人數',content:'login_num',css:'min-width: 130px;',sort:'login_num'},
        {title:'儲值次數',content:'recharge_num',css:'min-width: 110px;',sort:'recharge_num'},
        {title:'儲值金額',content:'recharge',css:'min-width: 110px;',sort:'recharge'},
        {title:'推播狀態',content:'is_enable',type:3},
        {title:'簡訊狀態',content:'sms_status',css:'min-width: 120px;',sort:'sms_status',type:3},
        {title:'操作',content:'gg',type:3},
    ];

    tcontent_once_push_type = [
        {title:'名稱',content:'name'},
        {title:'標題',content:'title_tpl'},
        {title:'內容',content:'content_tpl'},
        {title:'App導入頁面',content:'route_sign',type:3},
        {title:'狀態',content:'is_enable',type:3},
        {title:'建立時間',content:'create_dt'},
        {title:'操作',content:'gg',type:3},
    ];


    tcontent_push = [
        {title:'預覽畫面',content:'view',type:3,css:'max-width: 400px;'},
        {title:'模板名稱',content:'name'},
        {title:'推播時間',content:'real_push_times'},
        {title:'配對數',content:'match_num',css:'min-width: 150px;',sort:'match_num'},
        {title:'推播數',content:'push_num',css:'min-width: 150px;',sort:'push_num'},
        {title:'點擊數',content:'click_num',css:'min-width: 150px;',sort:'click_num'},
        {title:'點擊率',content:'click_per',css:'min-width: 150px;',sort:'click_per'},
        {title:'狀態',content:'is_enable_name'},
        // {title:'操作',content:'gg',type:3},
    ];



    tag_list_type:any[] = [
        { "id": '-1', "name": "請選擇tag類別" },
        { "id": '1', "name": "時間類別" },
        { "id": '2', "name": "儲值類別" },
    ]

    groupTagArr = [];
    groupTagArr1 = [];
    tool_obj:any={tag:'-2',tag1:'-2'};
    oriNum = 0;
    oriNum1 = 0;
    recharge_num = 0;
    recharge = 0;
    valuetag = [];
    key = '';
    time :any={};
    timeset = [{ type:1 , name: "今天", num: -0 },{ type:3 , name: "昨天", num: -1 },{ type:1 , name: "過去7天", num: -7 },{ type:1 , name: "過去30天", num: -30 }, ,{ type:2 , name: "上個月", num: -1 }, { type:2 , name: "上上個月", num: -2 }];

    search_notification = '-1';
    search_gender = '-1';
    search_time = '-1';
    search_is_enable = '-1';
    route_sign:any[] = [
        // { "id": '1', "name": "打開App" },
        // { "id": '2', "name": "探索頁-最新" },
        // { "id": '3', "name": "動態頁-熱門" },
        // { "id": '4', "name": "動態頁-私密話題" },
        // { "id": '5', "name": "動態明細內頁" },
        // { "id": '11', "name": "個人頁" },
        { "id": '1', "name": "打開App" },
        { "id": '201', "name": "探索頁-最新" },
        { "id": '202', "name": "探索頁-為你推薦" },
        { "id": '203', "name": "探索頁-關注" },
        { "id": '206', "name": "探索頁-潛力" },
        { "id": '207', "name": "探索頁-大戶" },
        { "id": '208', "name": "探索頁-電愛西施" },
        { "id": '209', "name": "探索頁-音蕩女郎" },
        { "id": '4', "name": "探索頁-必追熱門女神" },
        { "id": '301', "name": "動態頁-關注" },
        { "id": '306', "name": "動態頁-精選" },
        { "id": '5', "name": "動態明細內頁" },
        { "id": '6', "name": "對象聊天室" },
        { "id": '11', "name": "個人頁" },
        { "id": '14', "name": "女性收益報表" },
        { "id": '16', "name": "聊天列表" },
        { "id": '20', "name": "女會員系統頁" },
    ]

    Notification_method_list:any[] = [
        { "id": '-1', "name": "通知方式不限" },
        { "id": '1', "name": "推播" },
        { "id": '2', "name": "簡訊" },
        { "id": '3', "name": "推播+簡訊" },
    ]


    groupTaglist:any[] = [
        { "id": '-1', "name": "上線時間" },
        { "id": '1', "name": "上線時間A" },
        { "id": '2', "name": "上線時間B" },
    ]

    gender_list:any[] = [
        { "id": '-1', "name": "推播性別不限" },
        { "id": '1', "name": "男" },
        { "id": '2', "name": "女" },
    ]

    is_enable_list:any[] = [
        { "id": '0', "name": "停用" },
        { "id": '1', "name": "啟用" },
    ]

    is_enable_push_list:any[] = [
        { "id": '-1', "name": "不推(沒有配對到)" },
        { "id": '0', "name": "待配對" },
        { "id": '1', "name": "待推" },
        { "id": '2', "name": "已推" },
        { "id": '3', "name": "已統計" },
    ]

    once_push:any={inform_method:'',title:'',content:'',push_time:'',is_enable:'-2'}

    // checkpusher(){

    //     if(this.edit_data.gender == '1'){
    //         this.edit_data.target = '1';
    //     }else{
    //         this.edit_data.target = '2';
    //     }

    // }

    banimate:string = environment.picfile+'banimate.jpg';
    buser:string = environment.picfile+'buser.jpg';
    ganimate:string = environment.picfile+'ganimate.jpg';
    guser:string = environment.picfile+'guser.jpg';
    banimatefleeze:string = environment.picfile+'banimatefleeze.png';
    buserfleeze:string = environment.picfile+'buserfleeze.png';
    ganimatefleeze:string = environment.picfile+'ganimatefleeze.png';
    guserfleeze:string = environment.picfile+'guserfleeze.png';
    sys_logo:string = environment.picfile+'sys_logo.png';
    sort_obj:any = {column:'id',sort:'0'}

    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    default_type(){
        this.edit_data = {name:'',title_tpl:'',content_tpl:'',route_sign:'-2',is_enable:'1',};
    }

    close_push(item){
        item.is_enable = '-2';

        let body = {};

        body = {type:7,data:item};

        this.httpClient.post<any>("/update_push_v2.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                Swal.fire("已儲存完成!", "", "success");

                this.init_list();
            }
        });
    }

    save_one_push_type(item){

        if(item.route_sign == '-2'){
            alert('請選擇App導入頁面');
            return;
        }

        let body = {};

        body = {type:6,data:item};

        this.httpClient.post<any>("/update_push_v2.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                Swal.fire("已儲存完成!", "", "success");

                this.init_list();
            }
        });

    }

    save_one_push(item){

        let body = {};

        body = {type:5,data:item};

        this.httpClient.post<any>("/update_push_v2.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){

                Swal.fire("已更新完成!", "", "success");

                this.init_list();
            }
        });

        console.log('item',this.once_push)
    }

    handleRangeSelected(value: any): void {
        console.log('value',value);
        let eventDate = value.event;
        console.log('eventDate',eventDate);
        // 預設為空字符串
        this.time.startDate = '';
        this.time.endDate = '';

        if (eventDate && eventDate.startDate) {
          // 如果有選擇日期，使用選擇的日期
          this.time.startDate = moment(eventDate.startDate).format('YYYY-MM-DD');
          this.time.endDate = moment(eventDate.endDate).format('YYYY-MM-DD');
        } else {
          // 預設為昨天的日期
          const yesterday = moment().subtract(1, 'days');
          this.time.startDate = yesterday.format('YYYY-MM-DD');
          this.time.endDate = yesterday.format('YYYY-MM-DD');
        }
        this.init_list();
    }

    checkbtn(editem,item){

        let itemstatus = false;
        if(editem.length > 0){
            editem.forEach(v => {
                if(v.is_enable == 1){
                    itemstatus = true;
                }
            });
        }

        if(itemstatus == false){

            Swal.fire("最少要一組標題存在!", "", "error");
            item.is_enable = 1;

        }


    }


    next(){
        this.sub_now = '3';
    }

    defaultdata(){
        this.edit_data ={info:{has_pic:0,is_fuzzy:0,available_week:[0,1,2,3,4,5,6]},ps_id:'1',gender:'1',target:'4',route_sign:'-1',title_tpl:'',content_tpl:'',name:'',is_enable:'1'};
        this.edit_data.title_tpl = '';
        this.edit_data.content_tpl = '';
        this.edit_data.info.has_pic = 0;
        this.edit_data.info.is_fuzzy = 0;
        this.groupTagArr = [];
        this.groupTagArr1 = [];
        this.tool_obj.tag1 = '-2';
        this.tool_obj.tag = '-2';
    }

    clearbtn(item,idx,index){

        this.groupTagArr[idx].splice(index, 1);

        if(this.tool_obj.groupTag.includes(item)){
            const index = this.tool_obj.groupTag.indexOf(item);
            this.ngZone.run(() => {
                this.tool_obj.groupTag.splice(index, 1);
                this.tool_obj.groupTag = [...this.tool_obj.groupTag];
                this.cdr.detectChanges(); // 或者使用 this.cdr.markForCheck();
            });
        }

    }


    clearbtn1(item,idx,index){

        this.groupTagArr1[idx].splice(index, 1);

        if(this.tool_obj.groupTag1.includes(item)){
            const index = this.tool_obj.groupTag1.indexOf(item);
            this.ngZone.run(() => {
                this.tool_obj.groupTag1.splice(index, 1);
                this.tool_obj.groupTag1 = [...this.tool_obj.groupTag1];
                this.cdr.detectChanges(); // 或者使用 this.cdr.markForCheck();
            });
        }

    }

    ck_date(list,id){
    // console.log(list,id,this.edit_data);
        const index = this.edit_data.info.available_week.findIndex((v)=>{
            return v == id;
        })

        if(index==-1){
            list.push(id);
        }else{
            list.splice(index,1);
        }
    }


    save_push_type_tpl_list(item){
        this.loading = true;
        const body = {
            page: this.pageobj.page,count:this.pageobj.count,action:1,item:item
        };

        this.httpClient.post<any>("/push_type_tpl.php",body).subscribe(res => {
            this.loading = false;
            Swal.fire("已更新完成!", "", "success");
            this.init_push_type_tpl_list();

        });

    }

    choose(value:string){

		const bodyElement = document.querySelector('body.hold-transition.sidebar-mini');
		if (bodyElement) {
			// 修改css
			if(value =='5'){
				  	bodyElement.setAttribute('style', 'width: max-content');
			}else{
				bodyElement.removeAttribute('style');
			}

		}

        this.data = [];
        this.menu_now = value;
        this.varable_list = [
            {id:'{{user_name}}',name:'推薦對象'},
            {id:'{{self_user_name}}',name:'推播對象'},
            {id:'{{rand_1_9_num}}',name:'隨機一位數'},
            {id:'{{rand_10_99_num}}',name:'隨機二位數'},
            {id:'{{rand_100_999_num}}',name:'隨機三位數'},
        ]


        if(value=='3'){

            this.init_push_type_tpl_list();

        }else{

            this.menu_now = value;
            this.pageobj.total_count = 0;
            this.pageobj = {page:0,count:10,total_count:0};
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
            this.init_list();

        }




    }

    showdeType(num){

        if(this.groupTagArr[num] != null){
            this.tool_obj.groupTag  = this.groupTagArr[num];
        }

    }

    showdeType1(num){
        if(this.groupTagArr1[num] != null){
            this.tool_obj.groupTag1  = this.groupTagArr1[num];
        }
    }

    showType(num){

        if(this.groupTagArr.length == 0){ //一開始第一個值

                this.groupTagArr[num] = this.tool_obj.groupTag;
        }

        if(num == this.oriNum){

            if(this.tool_obj.groupTag.length <  this.groupTagArr[num].length){

                this.groupTagArr[num] =  this.groupTagArr[num].filter(item => this.tool_obj.groupTag.includes(item));

            }else{

                this.tool_obj.groupTag.forEach(item => {


                    if (!this.groupTagArr[num].includes(item)) {
                        this.groupTagArr[num].push(item);
                    }

                });

            }


        }else{ //新類型第一個值

            this.groupTagArr[num] = this.tool_obj.groupTag;
        }


        this.oriNum = num;
        // this.init_list();

    }


    showType1(num){

        if(this.groupTagArr1.length == 0){ //一開始第一個值

                this.groupTagArr1[num] = this.tool_obj.groupTag1;
        }


        if(num == this.oriNum1){

            if(this.tool_obj.groupTag1.length <  this.groupTagArr1[num].length){

                this.groupTagArr1[num] =  this.groupTagArr1[num].filter(item => this.tool_obj.groupTag1.includes(item));

            }else{

                this.tool_obj.groupTag1.forEach(item => {

                    if (!this.groupTagArr1[num].includes(item)) {
                        this.groupTagArr1[num].push(item);
                    }

                });

            }


        }else{ //新類型第一個值

            this.groupTagArr1[num] = this.tool_obj.groupTag1;
        }


        this.oriNum1 = num;
        // this.init_list();

    }

    init_push_type_tpl_list(){

        this.loading = true;
        const body = {
            page: this.pageobj.page,count:this.pageobj.count,action:0,search_gender:this.search_gender,search_is_enable:this.search_is_enable
        };

        this.httpClient.post<any>("/push_type_tpl.php",body).subscribe(res => {
            this.loading = false;
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
            if(res.status){
              this.data = res.data
              this.pageobj.total_count = res.total_count
            }else{
              this.pageobj.total_count = 0
              this.data = [];
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });
    }

    default_page(){
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
        this.init_list();
    }

    init_list(){

		const bodyElement = document.querySelector('body.sidebar-mini');
		if(this.menu_now !='5'){
			bodyElement.removeAttribute('style');
		}

        this.loading = true;
        const body = {
            page: this.pageobj.page,count:this.pageobj.count,
            search_type_id:this.search_type_id,
            search:this.search_model,
            sort:this.sort_model,
            menu_now:this.menu_now,
            order:this.order_model,
            search_gender:this.search_gender,
            search_time:this.search_time,
            search_notification:this.search_notification,
            time:this.time,
            sort_obj:this.sort_obj,
        };

        this.httpClient.post<any>("/get_push_list_v2.php",body).subscribe(res => {
            this.loading = false;
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
            this.tag_list_type = res.groupTaglist.top;
            this.groupTaglist = res.groupTaglist.bottom;
            this.valuetag = res.groupTaglist.valuetag
            this.recharge = res.recharge;
            this.recharge_num = res.recharge_num;
            this.push_num = res.push_num;
            this.click_num_rate = res.click_num_rate;
            this.sms_push_num = res.sms_push_num;
            this.sms_click_num_rate = res.sms_click_num_rate;

            if(this.search_type_id == '-1'){
                this.type_list = res.type_list;
            }

            this.time_list = res.time_list;
            if(res.status){
              	this.data = res.data
				bodyElement.removeAttribute('style');

				if (bodyElement &&this.data.length > 0 ) {
					// 修改css
					if(this.menu_now =='5'){
						bodyElement.setAttribute('style', 'width: max-content');
					}
				}
              this.pageobj.total_count = res.total_count
            }else{
              this.pageobj.total_count = 0
              this.data = [];
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
        });
    }

    callback(pageobj:page){

        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }

    }

    add_new_title(){
        this.edit_data.muti_title.push({id:-1,title_tpl:'',content_tpl:'',pt_id:this.edit_data.id,status:1})
    }

    checktag(){

        let receiver_user_tag = this.edit_data.info.receiver_user_tag;
        let recommended_user_tag = this.edit_data.info.recommended_user_tag;


        this.tool_obj.groupTag = [];
        this.tool_obj.groupTag1 = [];
        this.groupTagArr = [];
        this.groupTagArr1 = [];


        if(receiver_user_tag != undefined){
            receiver_user_tag.forEach(v => {
                this.valuetag.forEach((value,key) => {

                    value.forEach(vx => {
                        if(vx.id == v){
                            this.tool_obj.groupTag = [];
                            this.tool_obj.tag = key;
                            this.tool_obj.groupTag=[vx.name];
                            this.showType(this.tool_obj.tag);

                        }
                    });

                });
            });
        }

        if(recommended_user_tag != undefined){
            recommended_user_tag.forEach(v => {
                this.valuetag.forEach((value,key) => {

                    value.forEach(vx => {
                        if(vx.id == v){

                            this.tool_obj.tag1 = key;
                            this.tool_obj.groupTag1 = [vx.name];
                            this.showType1(this.tool_obj.tag1);

                        }
                    });

                });
            });
        }

        this.tool_obj.tag = '-2';
        this.tool_obj.tag1 = '-2';
    }

    save(item,type){ // -1上下架  1多標題  2設定檔

        if(item.info.is_split == '' || item.info.is_split == 0 || item.info.is_split == null){
            item.info.is_split = 1;
        }

        this.loading = true;
        let body = {};
        if(this.menu_now=='2'){
            body = {
                type:type,data:item,groupTagArr:this.groupTagArr,groupTagArr1:this.groupTagArr1
            };
        }else{
            body = {type:4,data:item};
        }

        this.httpClient.post<any>("/update_push_v2.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                if(type == 3){
                    Swal.fire("已新增完成!", "", "success");
                }else{
                    Swal.fire("已更新完成!", "", "success");
                }
                this.init_list();
            }
        });
    }

    handleStatusChange(newStatus: any) {
        newStatus.is_enable = newStatus.changestatus;
        this.save(newStatus,-1)
    }

    select(event) {
        const start = event.target.selectionStart;
        const end = event.target.selectionEnd;
        this.mouse_obj.start = start;
        this.mouse_obj.end = end;
    }


    add_var(item){
        if(this.menu_now=='1'){
            console.log(this.mouse_obj.target );
            const prestr = this.edit_data.content_tpl.substr(0,this.mouse_obj.start);
            const aftstr = this.edit_data.content_tpl.substr(this.mouse_obj.end)
            this.edit_data.content_tpl = `${prestr}${item}${aftstr}`
        }else{
            const select_key = this.mouse_obj.target == 0 ? 'title_tpl':'content_tpl';
            const prestr = this.edit_data.muti_title[this.mouse_obj.select][select_key].substr(0,this.mouse_obj.start)
            const aftstr = this.edit_data.muti_title[this.mouse_obj.select][select_key].substr(this.mouse_obj.end)
            this.edit_data.muti_title[this.mouse_obj.select][select_key] = `${prestr}${item}${aftstr}`
        }
    }

    add_var_tpl(item){

        const select_key = this.mouse_obj.target == 0 ? 'title_tpl':'content_tpl';
        const prestr = this.edit_data[select_key].substr(0,this.mouse_obj.start)
        const aftstr = this.edit_data[select_key].substr(this.mouse_obj.end)
        this.edit_data[select_key] = `${prestr}${item}${aftstr}`

    }

    adds_var(item){

        let select_key = '';
        if(this.key == ''){
            select_key = 'title_tpl';
        }else{
            select_key = this.key;
        }

        this.edit_data[select_key] = this.edit_data[select_key] + `${item}`;
    }
}
